import React from 'react';

import { Box, Chip, Typography } from '@mui/material';

type Props = {
  paymentTermsGlobal: 'eft' | 'vcc';
  hasVCC: boolean;
};

export function CustomOfferVendorVirtualCreditCardSectionHeading({ paymentTermsGlobal, hasVCC }: Props) {
  const isEftWithVCC = paymentTermsGlobal === 'eft' && hasVCC;
  const errorMessage =
    'A VCC has already been created for this custom offer. Please proceed with VCC payment as it is preferred method. Please reach out to finance team to cancel otherwise.';

  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h6">Virtual Credit Card (VCC) (Vendor Payments)</Typography>
        <Chip label="New" color="primary" size="small" />
      </Box>
      <Typography variant="subtitle1" color={isEftWithVCC ? 'error' : 'text.secondary'}>
        {isEftWithVCC && errorMessage}
      </Typography>
    </>
  );
}
